/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Resource } from '../../models/resource';

export interface ResourceControllerQueryResources$Params {

/**
 * Provider id
 */
  providerId: string;

/**
 * Actor id
 */
  actorId?: string;

/**
 * App id
 */
  appId?: string;

/**
 * Resource type
 */
  resourceType?: string;

/**
 * Order by modification date
 */
  orderByModificationDate?: boolean;

/**
 * Return metadata only
 */
  returnMetadataOnly?: boolean;

/**
 * Max nr of results
 */
  maxResults?: number;

/**
 * page number
 */
  pageNumber?: number;

/**
 * Only return resources stored on the server at or after this ISO 8601 date (metadata.publishedServer)
 */
  modifiedSince?: string;
}

export function resourceControllerQueryResources(http: HttpClient, rootUrl: string, params: ResourceControllerQueryResources$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Resource>>> {
  const rb = new RequestBuilder(rootUrl, resourceControllerQueryResources.PATH, 'get');
  if (params) {
    rb.query('providerId', params.providerId, {});
    rb.query('actorId', params.actorId, {});
    rb.query('appId', params.appId, {});
    rb.query('resourceType', params.resourceType, {});
    rb.query('orderByModificationDate', params.orderByModificationDate, {});
    rb.query('returnMetadataOnly', params.returnMetadataOnly, {});
    rb.query('maxResults', params.maxResults, {});
    rb.query('pageNumber', params.pageNumber, {});
    rb.query('modifiedSince', params.modifiedSince, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Resource>>;
    })
  );
}

resourceControllerQueryResources.PATH = '/resources';
